export const isWebview = () => {
  const route = useRoute()
  return (
    typeof route.fullPath === 'string' &&
    (route.fullPath.includes('webviews') || route.fullPath.includes('embedded'))
  )
}
